/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimReservationResponse } from './ClaimReservationResponse';
import {
    ClaimReservationResponseFromJSON,
    ClaimReservationResponseFromJSONTyped,
    ClaimReservationResponseToJSON,
} from './ClaimReservationResponse';
import type { ResultRange } from './ResultRange';
import {
    ResultRangeFromJSON,
    ResultRangeFromJSONTyped,
    ResultRangeToJSON,
} from './ResultRange';
import type { PageSort } from './PageSort';
import {
    PageSortFromJSON,
    PageSortFromJSONTyped,
    PageSortToJSON,
} from './PageSort';

/**
 * 
 * @export
 * @interface PageClaimReservationResponse
 */
export interface PageClaimReservationResponse {
    /**
     * 
     * @type {Array<ClaimReservationResponse>}
     * @memberof PageClaimReservationResponse
     */
    results: Array<ClaimReservationResponse>;
    /**
     * 
     * @type {number}
     * @memberof PageClaimReservationResponse
     */
    totalResults: number;
    /**
     * 
     * @type {PageSort}
     * @memberof PageClaimReservationResponse
     */
    sort: PageSort;
    /**
     * 
     * @type {ResultRange}
     * @memberof PageClaimReservationResponse
     */
    resultRange: ResultRange;
}

/**
 * Check if a given object implements the PageClaimReservationResponse interface.
 */
export function instanceOfPageClaimReservationResponse(value: object): value is PageClaimReservationResponse {
    if (!('results' in value) || value['results'] === undefined) return false;
    if (!('totalResults' in value) || value['totalResults'] === undefined) return false;
    if (!('sort' in value) || value['sort'] === undefined) return false;
    if (!('resultRange' in value) || value['resultRange'] === undefined) return false;
    return true;
}

export function PageClaimReservationResponseFromJSON(json: any): PageClaimReservationResponse {
    return PageClaimReservationResponseFromJSONTyped(json, false);
}

export function PageClaimReservationResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageClaimReservationResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'results': ((json['results'] as Array<any>).map(ClaimReservationResponseFromJSON)),
        'totalResults': json['totalResults'],
        'sort': PageSortFromJSON(json['sort']),
        'resultRange': ResultRangeFromJSON(json['resultRange']),
    };
}

export function PageClaimReservationResponseToJSON(value?: PageClaimReservationResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'results': ((value['results'] as Array<any>).map(ClaimReservationResponseToJSON)),
        'totalResults': value['totalResults'],
        'sort': PageSortToJSON(value['sort']),
        'resultRange': ResultRangeToJSON(value['resultRange']),
    };
}

